module.exports = __webpack_public_path__ + "static/media/TSC_Cards@3x.686fc3b0.png";